// import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import BlogManagement from './BlogManagement';
// import FacebookLinkManagement from './FacebookLinkManagement';
// import VideoLinkManagement from './VideoLinkManagement';
// import './Home.css';

// const API_URL = 'https://apipurple.topranohotelandlounge.com';

// // Axios interceptor
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error('API Error:', error.message);
//     return Promise.reject(error);
//   }
// );

// function Home() {
//   const [activeTab, setActiveTab] = useState('dashboard');

//   const [blogs, setBlogs] = useState([]);
//   const [facebookLinks, setFacebookLinks] = useState([]);
//   const [videoLinks, setVideoLinks] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');
//   const [retryCount, setRetryCount] = useState(0);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     setError('');
//     setMessage('');

//     try {
//       const endpoints = [
//         `${API_URL}/api/blogs`,
//         `${API_URL}/api/facebooklink`,
//         `${API_URL}/api/videoslinks`
//       ];

//       const [
//         blogsRes,
//         facebookLinksRes,
//         videoLinksRes
//       ] = await Promise.all(
//         endpoints.map(url => axios.get(url, { timeout: 10000 }))
//       );

//       setBlogs(Array.isArray(blogsRes.data) ? blogsRes.data : []);

//       setFacebookLinks(
//         Array.isArray(facebookLinksRes.data)
//           ? facebookLinksRes.data.filter(link => link && link.id)
//           : []
//       );

//       let videoLinksData = [];
//       if (Array.isArray(videoLinksRes.data?.data)) {
//         videoLinksData = videoLinksRes.data.data;
//       } else if (Array.isArray(videoLinksRes.data)) {
//         videoLinksData = videoLinksRes.data;
//       }

//       setVideoLinks(videoLinksData);

//       setRetryCount(0);
//     } catch (err) {
//       console.error('Fetch error:', err);

//       if (retryCount < 3) {
//         setError(`Failed to load data. Retrying (${retryCount + 1}/3)...`);
//         setTimeout(() => {
//           setRetryCount(prev => prev + 1);
//           fetchData();
//         }, 2000);
//       } else {
//         setError('Failed to load data. Please check your connection.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [retryCount]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handleUpdate = (msg) => {
//     fetchData();
//     setMessage(msg || 'Update successful!');
//     setTimeout(() => setMessage(''), 5000);
//   };

//   if (loading && retryCount === 0) {
//     return (
//       <div className="admin-dashboard">
//         <div className="loading">
//           <div className="spinner"></div>
//           <p>Loading Dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="admin-dashboard">
//       <div className="admin-header">
//         <h1 className="admin-title">Admin Dashboard</h1>

//         {message && <div className="alert alert-success">{message}</div>}
//         {error && <div className="alert alert-error">{error}</div>}

//         <div className="admin-tabs">
//           {[
//             { id: 'dashboard', label: 'Dashboard' },
//             { id: 'blogs', label: `Blogs (${blogs.length})` },
//             { id: 'facebookLinks', label: `Facebook Links (${facebookLinks.length})` },
//             { id: 'videoLinks', label: `Video Links (${videoLinks.length})` }
//           ].map(tab => (
//             <button
//               key={tab.id}
//               className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
//               onClick={() => setActiveTab(tab.id)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="admin-content">
//         {activeTab === 'dashboard' && (
//           <DashboardTab
//             blogs={blogs}
//             facebookLinks={facebookLinks}
//             videoLinks={videoLinks}
//             setActiveTab={setActiveTab}
//           />
//         )}

//         {activeTab === 'blogs' && (
//           <BlogManagement blogs={blogs} onUpdate={handleUpdate} />
//         )}

//         {activeTab === 'facebookLinks' && (
//           <FacebookLinkManagement
//             facebookLinks={facebookLinks}
//             onUpdate={handleUpdate}
//           />
//         )}

//         {activeTab === 'videoLinks' && (
//           <VideoLinkManagement
//             videoLinks={videoLinks}
//             onUpdate={handleUpdate}
//           />
//         )}
//       </div>
//     </div>
//   );
// }

// function DashboardTab({ blogs, facebookLinks, videoLinks, setActiveTab }) {
//   const stats = [
//     {
//       title: 'Total Blogs',
//       value: blogs.length,
//       action: () => setActiveTab('blogs')
//     },
//     {
//       title: 'Facebook Links',
//       value: facebookLinks.length,
//       action: () => setActiveTab('facebookLinks')
//     },
//     {
//       title: 'Video Links',
//       value: videoLinks.length,
//       action: () => setActiveTab('videoLinks')
//     }
//   ];

//   return (
//     <div className="stats-grid">
//       {stats.map((stat, i) => (
//         <div key={i} className="stat-card clickable" onClick={stat.action}>
//           <div className="stat-title">{stat.title}</div>
//           <div className="stat-value">{stat.value}</div>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Home;




//http://localhost:8001

// Home.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import BlogManagement from './BlogManagement';
import FacebookLinkManagement from './FacebookLinkManagement';
import VideoLinkManagement from './VideoLinkManagement';
// import SuiteTypeManagement from './SuiteTypeManagement'; // <-- import new component
import './Home.css';
import SuiteTypeManagement from './SuiteTypeManagement';
const API_URL = 'https://apipurple.topranohotelandlounge.com';
//suite
// Axios interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.message);
    return Promise.reject(error);
  }
);

function Home() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const [blogs, setBlogs] = useState([]);
  const [facebookLinks, setFacebookLinks] = useState([]);
  const [videoLinks, setVideoLinks] = useState([]);

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [retryCount, setRetryCount] = useState(0);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const endpoints = [
        `${API_URL}/api/blogs`,
        `${API_URL}/api/facebooklink`,
        `${API_URL}/api/videoslinks`
      ];

      const [blogsRes, facebookLinksRes, videoLinksRes] =
        await Promise.all(endpoints.map(url => axios.get(url, { timeout: 10000 })));

      setBlogs(Array.isArray(blogsRes.data) ? blogsRes.data : []);
      setFacebookLinks(
        Array.isArray(facebookLinksRes.data)
          ? facebookLinksRes.data.filter(link => link && link.id)
          : []
      );

      let videoLinksData = [];
      if (Array.isArray(videoLinksRes.data?.data)) {
        videoLinksData = videoLinksRes.data.data;
      } else if (Array.isArray(videoLinksRes.data)) {
        videoLinksData = videoLinksRes.data;
      }
      setVideoLinks(videoLinksData);

      setRetryCount(0);
    } catch (err) {
      console.error('Fetch error:', err);

      if (retryCount < 3) {
        setError(`Failed to load data. Retrying (${retryCount + 1}/3)...`);
        setTimeout(() => {
          setRetryCount(prev => prev + 1);
          fetchData();
        }, 2000);
      } else {
        setError('Failed to load data. Please check your connection.');
      }
    } finally {
      setLoading(false);
    }
  }, [retryCount]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleUpdate = (msg) => {
    fetchData();
    setMessage(msg || 'Update successful!');
    setTimeout(() => setMessage(''), 5000);
  };

  if (loading && retryCount === 0) {
    return (
      <div className="admin-dashboard">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1 className="admin-title">Admin Dashboard</h1>

        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-error">{error}</div>}

        <div className="admin-tabs">
          {[
            { id: 'dashboard', label: 'Dashboard' },
            { id: 'blogs', label: 'Blogs' },
            { id: 'facebookLinks', label: 'Facebook Links' },
            { id: 'videoLinks', label: 'Video Links' },
            { id: 'suites', label: 'Create/Edit Suites' } // <-- static tab label
          ].map(tab => (
            <button
              key={tab.id}
              className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="admin-content">
        {activeTab === 'dashboard' && (
          <DashboardTab
            blogs={blogs}
            facebookLinks={facebookLinks}
            videoLinks={videoLinks}
            setActiveTab={setActiveTab}
          />
        )}

        {activeTab === 'blogs' && (
          <BlogManagement blogs={blogs} onUpdate={handleUpdate} />
        )}

        {activeTab === 'facebookLinks' && (
          <FacebookLinkManagement
            facebookLinks={facebookLinks}
            onUpdate={handleUpdate}
          />
        )}

        {activeTab === 'videoLinks' && (
          <VideoLinkManagement
            videoLinks={videoLinks}
            onUpdate={handleUpdate}
          />
        )}

        {activeTab === 'suites' && (
          <SuiteTypeManagement onUpdate={handleUpdate} />
        )}
      </div>
    </div>
  );
}

function DashboardTab({ blogs, facebookLinks, videoLinks, setActiveTab }) {
  const stats = [
    { title: 'Total Blogs', value: blogs.length, action: () => setActiveTab('blogs') },
    { title: 'Facebook Links', value: facebookLinks.length, action: () => setActiveTab('facebookLinks') },
    { title: 'Video Links', value: videoLinks.length, action: () => setActiveTab('videoLinks') },
    { title: 'Suites', value: '-', action: () => setActiveTab('suites') } // <-- static
  ];

  return (
    <div className="stats-grid">
      {stats.map((stat, i) => (
        <div key={i} className="stat-card clickable" onClick={stat.action}>
          <div className="stat-title">{stat.title}</div>
          <div className="stat-value">{stat.value}</div>
        </div>
      ))}
    </div>
  );
}

export default Home;